export const isForbidden = (err: unknown) => (err as any)?.response?.status === 403;
